import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      {/* Image de fond */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://effet-conseil.com/wp-content/uploads/2026/04/image_0obsdxbf.jpg)]" />
      </div>

      {/* Overlay teinté bordeaux */}
      <div className="absolute inset-0 z-[1] bg-[hsl(343,40%,15%)]/55" />

      {/* Contenu */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 w-full max-w-7xl mx-auto mt-16 md:mt-0">
        <style dangerouslySetInnerHTML={{
        __html: `
              .hero-text-shadow {
                text-shadow: 0 2px 12px rgba(0,0,0,0.6), 0 4px 30px rgba(0,0,0,0.4);
              }
              .hero-subtext-shadow {
                text-shadow: 0 1px 8px rgba(0,0,0,0.5), 0 2px 20px rgba(0,0,0,0.3);
              }
              :root {
                --foreground: hsl(343 80% 35%);
                --accent-foreground: hsl(343 80% 35%);
                --ring: hsl(343 80% 35%);
              }
              @keyframes shadowPulse {
                0% { box-shadow: 0 0 0 0 rgba(98, 117, 29, 0.7); }
                70% { box-shadow: 0 0 0 20px rgba(98, 117, 29, 0); }
                100% { box-shadow: 0 0 0 0 rgba(98, 117, 29, 0); }
              }
              .animate-shadow-pulse {
                animation: shadowPulse 2s infinite;
              }
            `
      }} />

        <h1 className="hero-text-shadow font-serif text-white text-4xl sm:text-5xl md:text-[76px] font-bold leading-tight md:leading-[1.1] text-balance mb-6">
          <span className="block font-sans text-sm sm:text-base md:text-lg font-semibold uppercase tracking-[0.2em] leading-normal text-white/90 mb-4">
            Accompagnement certification RNCP et RS
          </span>
          Transformer vos projets de certification
          <br />
          en réussites durables&nbsp;
        </h1>

        <p className="hero-subtext-shadow font-sans text-white text-base sm:text-lg md:text-[18px] max-w-[600px] mx-auto mb-4 text-balance">
          Effet Conseil accompagne les porteurs de projets dans la création, le
          renouvellement et la sécurisation de leurs certifications RNCP et RS,
          avec une approche éthique et responsable.
        </p>

        {/* Signature — nom de la fondatrice */}
        <p className="hero-subtext-shadow font-serif italic text-white/90 text-sm sm:text-base md:text-[16px] mb-10">
          Christelle CHARRIER-ROBELIN — Fondatrice d'Effet Conseil
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full">
          <Button asChild variant="default" className="px-[40px] py-[16px] h-auto text-lg rounded-[2px] animate-shadow-pulse bg-[#B33D5A] hover:bg-[#B33D5A]/90 transition-colors">
            <Link to="/contact/#contact" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs has-[>svg]:px-3 px-[40px] py-[16px] h-auto text-lg rounded-[2px] animate-shadow-pulse transition-colors !bg-[hsl(343,80%,35%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-[#B33D5A]/90">
              Échanger sur votre projet
            </Link>
          </Button>

          <Button asChild variant="outline" className="px-[40px] py-[16px] h-auto text-lg rounded-[2px] border-white/40 text-white hover:bg-white/10 hover:text-white transition-colors border-2">
            <Link to="/certifications-rncp-rs/" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive bg-background shadow-xs has-[>svg]:px-3 px-[40px] py-[16px] h-auto text-lg rounded-[2px] border-white/40 transition-colors border-2 !text-[hsl(343,80%,35%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-white/10 hover:text-white">
              Découvrir mes services
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}